<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <div v-if="!loading">
      <loading-autocomplete
          v-if="!edit"
          class="mt-4"
          outlined
          placeholder="Введите ФИО и выберете из предложенных вариантов"
          label="Работник"
          v-model="replacement.parent"
          search-parameter="fio"
          :load-fios="false"
          :url="user_selector"
          :error="hasError('parent')"
          :errorMessages="getError('parent')"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать ФИО, <br> и либо остановитесь на 1 секунду, либо нажмите Enter
          </div>
        </template>
      </loading-autocomplete>
      <loading-autocomplete
          v-if="!edit"
          outlined
          placeholder="Введите ФИО и выберете из предложенных вариантов"
          label="Заместитель работника"
          v-model="replacement.user"
          search-parameter="fio"
          :load-fios="false"
          :url="user_selector"
          :error="hasError('user')"
          :errorMessages="getError('user')"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать ФИО, <br> и либо остановитесь на 1 секунду, либо нажмите Enter
          </div>
        </template>
      </loading-autocomplete>
      <v-select
          outlined
          :disabled="edit"
          :class="edit ? 'mt-4' : ''"
          v-model="replacement_selected_type"
          :items="replacement_type"
          item-value="value"
          item-text="text"
          label="Тип заместителя"
      ></v-select>
      <v-row no-gutters v-if="replacement_selected_type === 0">
        <v-col cols="12" sm="6" class="pr-sm-3">
          <date-picker
              key="start_date"
              v-model="replacement.start_date"
              label="Дата начала"
              outlined
              prepend-outer-icon
              icon="calendar_month"
              :allowed-dates="disablePastDates"
              :error="hasError('start_date')"
              :errorMessages="replaceErrorDateText(getError('start_date'))"
          ></date-picker>
        </v-col>
        <v-col cols="12" sm="6">
          <date-picker
              key="end_date"
              v-model="replacement.end_date"
              label="Дата окончания"
              outlined
              prepend-outer-icon
              icon="calendar_month"
              :allowed-dates="disableFutureDates"
              :date-static-lower="replacement.start_date"
              :error="hasError('end_date')"
              :errorMessages="replaceErrorDateText(getError('end_date'))"
          ></date-picker>
        </v-col>
      </v-row>
<!--      <v-text-field-->
<!--          v-model="replacement.max_auto_one_time"-->
<!--          label="Кол-во разовых автомобильных пропусков в месяц"-->
<!--          type="number"-->
<!--          outlined-->
<!--          :error="hasError('max_auto_one_time')"-->
<!--          :errorMessages="getError('max_auto_one_time')"-->
<!--      ></v-text-field>-->
<!--      <v-text-field-->
<!--          v-model="replacement.max_auto_constant"-->
<!--          label="Кол-во временных автомобильных пропусков в месяц"-->
<!--          type="number"-->
<!--          outlined-->
<!--          :error="hasError('max_auto_constant')"-->
<!--          :errorMessages="getError('max_auto_constant')"-->
<!--      ></v-text-field>-->
    </div>
    <div class="action mt-8 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import selectors from "@/urls/selectors";
import {SemipolarSpinner} from "epic-spinners";
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete";
import datePicker from "@/modules/core/components/DatePicker.vue";

export default {
  name: "AdminReplacementsEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    replacementData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog,
    SemipolarSpinner,
    LoadingAutocomplete,
    datePicker
  },
  data() {
    return {
      loading: false,
      save_loading: false,
      replacement_default: {
        parent: undefined,
        user: undefined,
        start_date: undefined,
        end_date: undefined
        // max_auto_one_time: null,
        // max_auto_constant: null,
      },
      replacement: undefined,
      replacement_type: [
        { value: 0, text: "Временный"},
        { value: 1, text: "Постоянный"}
      ],
      replacement_selected_type: 0
    }
  },
  watch: {
    replacement: {
      handler: function() {
        this.errors = {
          fields: {},
          non: []
        }
      },
      deep: true
    },
    "replacement_selected_type" () {
      if (this.replacement_selected_type === 1) {
        this.replacement.start_date = null
        this.replacement.end_date = null
      } else {
        this.replacement.start_date = new Date().toISOString().split("T")[0];
        this.replacement.end_date = undefined
      }
    }
  },
  computed: {
    form_title() {
      return this.edit === false ? "Добавить заместителя" : "Редактировать заместителя"
    },
    user_selector(){
      return selectors.SELECTORS.USERS.ALL()
    }
  },
  methods: {
    ...mapActions({
      createReplacement: "admin/createReplacements",
      changeReplacement: "admin/changeReplacements",
      loadReplacementDetail: "admin/loadReplacementsDetail"
    }),
    close(){
      this.$emit("close", false)
    },
    loadReplacementData(){
      this.loading = true
      if(this.replacementData === undefined){
        this.replacement = this.replacement_default
        this.replacement.start_date = new Date().toISOString().split("T")[0];
        this.loading = false
      }
      else{
        this.replacement = JSON.parse(JSON.stringify(this.replacementData))
        this.loadReplacementDetail({
          url: undefined,
          id: this.replacement.id,
          finalizer: (data) => {
            if (data.start_date === null) {
              this.replacement_selected_type = 1
            }
            this.replacement = data
            this.loading = false
          }
        })
      }
    },
    save(){
      this.save_loading = true

      if (this.edit) {
        let user = this.replacement.user.uid
        this.replacement.user = user
        let parent = this.replacement.parent.uid
        this.replacement.parent = parent

        this.changeReplacement({
          id: this.replacement.id,
          data: this.replacement,
          finalizer: () => {
            this.$emit("close", this.replacement)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      } else {
        this.createReplacement({
          data: this.replacement,
          finalizer: () => {
            this.$emit("close", this.replacement)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    },
    disablePastDates(val) {
      return val >= new Date().toISOString().split("T")[0]
    },
    disableFutureDates(val) {
      let limit = 90
      let date = new Date(new Date(this.replacement.start_date).setDate(new Date(this.replacement.start_date).getDate() + limit))
      return val <= date.toISOString().split("T")[0]
    },
    replaceErrorDateText(text) {
      if (typeof text === "object" && text !== null) {
        let tempString = text[0].replace("YYYY-MM-DD", "ДД.ММ.ГГГГ")
        tempString = tempString.replace("date", "даты")
        return [tempString]
      } return text
    }
  },
  created() {
    this.loadReplacementData()
  }
}
</script>

<style scoped>

</style>
